export default __webpack_public_path__ + "static/media/gallery_10.57f7ba32.jpg";